import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { JoinGame } from './components/Game/JoinGame';
import { JoinGroup } from './components/Game/JoinGroup';
import { ChooseTasks } from './components/Game/ChooseTasks';
import { PlayTasks } from './components/Game/PlayTasks';
import { ChooseGameResults } from './components/Results/ChooseGameResults';
import { ShowGameResults } from './components/Results/ShowGameResults';
import { AdminLogin } from './components/Admin/AdminLogin';
import { HostGame } from './components/Admin/HostGame';

export default class App extends Component {
  static displayName = App.name;

    constructor(props) {
        super(props);

        this.state = { showHosting : false }
    }

    showHostingNav(v) {
        this.setState({ showHosting: v });
    }

  render () {
      return (
          <Layout showHosting={this.state.showHosting}>
              <Route exact path='/' render={props => <Home {...props} showHostingNav={v => this.showHostingNav(v)} />} />
              <Route exact path='/play' render={props => <JoinGame {...props} showHostingNav={v => this.showHostingNav(v)} />} />
              <Route exact path='/play/join' render={props => <JoinGroup {...props} showHostingNav={v => this.showHostingNav(v)} />} />
              <Route exact path='/play/game' render={props => <ChooseTasks {...props} showHostingNav={v => this.showHostingNav(v)} />} />
              <Route exavt path='/play/game/tasks' render={props => <PlayTasks {...props} showHostingNav={v => this.showHostingNav(v)} />}  />
              <Route exact path='/results' render={props => <ChooseGameResults {...props} showHostingNav={v => this.showHostingNav(v)} />} />
              <Route exact path='/results/game' render={props => <ShowGameResults {...props} showHostingNav={v => this.showHostingNav(v)} />} />
              <Route exact path='/hosting' render={props => <AdminLogin {...props} showHostingNav={v => this.showHostingNav(v)} />}  />
              <Route exact path='/hosting/game' render={props => <HostGame {...props} showHostingNav={v => this.showHostingNav(v)} />}  />
        </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.jsx